var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"businessboard"},[_c('div',{staticClass:"businessboard--content"},[_c('h1',[_vm._v(_vm._s(_vm.$t('Businessboard.resultUnits')))]),_c('p')])])
}
var staticRenderFns = []

export { render, staticRenderFns }